import {
  invoicesViewColumns,
  invoicesSearchSchema,
  mapInvoicesViewQuery,
} from "./InvoicesView.default";
import ManagedGridView from "../../controls/ManagedGridView";
import { SearchQuery } from "../../code/search-query/search-query";
import { getInvoices } from "../../repository/data.repository";
import { createGridRequest } from "../../hooks/useGridRequest";
import { useSelector } from "../../store/store";
import { authorizeSelectors } from "../../store/authorize";

export interface InvoicesViewProps {
  readonly trigger?: string;
  readonly onAction?: (key: string, record: any) => void;
  readonly onSearch?: (searchQuery: SearchQuery) => void;
}

function InvoicesView(props: InvoicesViewProps) {
  const permissions = useSelector(authorizeSelectors.permissions);

  return (
    <ManagedGridView
      trigger={props.trigger}
      columns={invoicesViewColumns}
      schema={invoicesSearchSchema}
      mapQuery={mapInvoicesViewQuery}
      onSearch={props.onSearch}
      request={createGridRequest(getInvoices, { retry: true })}
      pageSize={100}
      actions={[
        {
          key: "view",
          label: "View",
          handler: (key, record) => props.onAction?.(key, record),
        },
        {
          key: "update",
          label: "Edit",
          disabled: !permissions.can("Invoices", "edit"),
          handler: (key, record) => props.onAction?.(key, record),
        },
        {
          key: "delete",
          label: "Delete",
          danger: true,
          disabled: !permissions.can("Invoices", "delete"),
          handler: (key, record) => props.onAction?.(key, record),
        },
      ]}
    />
  );
}

export default InvoicesView;
